import { AuthService } from './../../../services/auth.service';
import { NgxRolesService } from 'ngx-permissions';
import { SchoolAgenda } from './../../../models/school-agenda';
import { School } from './../../../models/school';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { Select2OptionData } from 'ng2-select2';
declare const google: any;

@Component({
  selector: 'app-school-view',
  templateUrl: './school-view.component.html',
  styleUrls: ['./school-view.component.css']
})
export class SchoolViewComponent implements OnInit {

  school: School;
  clients: any[];
  cityWeathers: any[];
  schoolAgendas: any[];
  days: {};
  map: any;
  mapZonesOfService: any;
  schoolMarker: any;
  zonesOfService: any;
  directionsService: any;
  directionsRenderer: any;
  selectedZoneIndex: any;
  firstPolygon: any;
  drawingManager: any;
  buses: any[];

  // ----- Start Ion Range Slider -----------
  ion_min = moment('0000', 'hmm').format('X');
  ion_max = moment('2359', 'hmm').format('X');
  ion_from = moment('0000', 'hmm').format('X');
  ion_to = moment('2359', 'hmm').format('X');
  hourFormat = function (num) {
    const m = moment(num, 'X');
    return m.format('HH:mm');
  };
  formatX = function (time: string) {
    return moment(time, 'h:mm').format('X');
  };
  // ----- Start Ion Range Slider -----------

  // ----- Start DatePicker -----------
  dateTimeFilter = (d: Date): boolean => {
    return true;
  }
  // ----- End DatePicker -----------

  filter = {
    clientId: '',
    schoolId: '',
    busId: '',
  };

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private authService: AuthService,
    private roleService: NgxRolesService
  ) {
    this.school = new School();
    this.schoolAgendas = [
      new SchoolAgenda('1'),
      new SchoolAgenda('2'),
      new SchoolAgenda('3'),
      new SchoolAgenda('4'),
      new SchoolAgenda('5')
    ];
    this.schoolAgendas[0].day = '1';
    this.days = {
      1: 'Lundi',
      2: 'Mardi',
      3: 'Mercredi',
      4: 'Jeudi',
      5: 'Vendredi'
    };
    this.route.params.subscribe(params => {
      this.http.get(
        '/api/school/' + params['id']
      ).subscribe((school: any) => {
        if (
          (this.roleService.getRole('ROLE_CLIENT') || this.roleService.getRole('ROLE_SUPER_CLIENT'))
          && this.authService.getUser().id !== school.clientId
        ) {
          this.router.navigate(['']);
        }
        this.school = school;
        this.filter.clientId = school.clientId;
        this.filter.schoolId = school.id;
        this.initMap();
        this.initBusSelect();
        if (school.hasOwnProperty('SchoolAgendas')) {
          for (let i = 0; i < school.SchoolAgendas.length; i++) {
            this.schoolAgendas[school.SchoolAgendas[i].day - 1] = school.SchoolAgendas[i];
          }
        }
      });
    });
    if (this.roleService.getRole('ROLE_ADMIN')) {
      this.http.get(
        '/api/client/lookup'
      ).subscribe((clients: any[]) => {
        this.clients = clients;
      });
    }
    this.http.get(
      '/api/cityWeather/lookup'
    ).subscribe((cityWeathers: any[]) => {
      this.cityWeathers = cityWeathers;
    });
  }

  ngOnInit() {
  }

  initMap() {
    const pos = (this.school) ? { lat: Number(this.school.lat), lng: Number(this.school.lng) } : { lat: 31.585832, lng: -6.183891 };
    let option = {
      center: pos,
      zoom: 12,
      gestureHandling: 'cooperative',
      scrollwheel: false,
    };
    this.map = new google.maps.Map(document.getElementById('map'), option);
    this.schoolMarker = new google.maps.Marker({
      position: pos,
      map: this.map,
      icon: 'assets/images/markers/school.png',
      draggable: true,
      zIndex: 100,
    });
  }

  initBusSelect() {
    this.filter.busId = '';
    let params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId,
        schoolId: this.filter.schoolId
      }
    });
    this.http.get(
      '/api/bus/lookup',
      { params }
    ).subscribe((buses: any[]) => {
      this.buses = buses;
    });
  }

  initMapZoneOfService() {
    
    const pos = (this.school) ? { lat: Number(this.school.lat), lng: Number(this.school.lng) } : { lat: 31.585832, lng: -6.183891 };

    this.directionsService    = new google.maps.DirectionsService;
    this.directionsRenderer   = new google.maps.DirectionsRenderer({ suppressMarkers: true });
    let option = {
      center: pos,
      zoom: 12,
      gestureHandling: 'cooperative',
      scrollwheel: false,
    };
    
    this.mapZonesOfService = new google.maps.Map(document.getElementById('zone-map'), option);
    this.directionsRenderer.setMap(this.mapZonesOfService);
    this.schoolMarker = new google.maps.Marker({
      position: pos,
      map: this.mapZonesOfService,
      icon: 'assets/images/markers/school.png',
      draggable: true,
      zIndex: 100,
    });


    // show all polygons in the map
    for (let i = 0; i < this.school.zonesOfService.length; i++) {
      
      // for Dynamic Zone
      if (this.school.zonesOfService[i].coordZone != 0 && this.school.zonesOfService[i].coordZone != null){
        // init with existe param when it's a zone edit
        
        //`coordinatesString` is the value retrieved from your database
        const storedCoordinatesString = this.school.zonesOfService[i].coordZone;

        // Parse the JSON string into an array of coordinates
        const storedCoordinates = JSON.parse(storedCoordinatesString) as { lat: number, lng: number }[];

        let  editDrawingCmd = false;

        // Draw the saved polygon on the map
        this.drawSavedPolygon(storedCoordinates,this.school.zonesOfService[i].Bus.colorLineBus,editDrawingCmd);
      }
    }
  }

  // Function to draw a polygon on the map
  drawSavedPolygon(coordinates: { lat: number, lng: number }[],color,editDrawingCmd) {
    const polygon = new google.maps.Polygon({
      paths: coordinates,
      strokeColor: color,
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: color,
      fillOpacity: 0.35,
      editable: editDrawingCmd, // You can set this to false if you don't want the polygon to be editable
      map: this.mapZonesOfService
    });

  }

  getBusColor(zoneOfServiceBusId: string): string {
    const bus = this.buses.find(bus => bus.id == zoneOfServiceBusId);
    return bus ? bus.colorLineBus : '';
  }

  showAllZonesOfService(){
    $('#ModalZones').modal('show');
    setTimeout(() => {
      this.initMapZoneOfService();
    }, 500);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/school/school-view/school-view.component.ts